import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Card, CardHeader, Container, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, MenuItem, Switch, TextField, Tooltip, Typography, styled } from '@mui/material'
import { Formik } from 'formik'
import * as Yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import { toast } from 'react-toastify';


export default function SupplierDialog({ dialogOpen, setDialogOpen, updateID, setUpdateID }) {
    const [supplierData, setSupplierData] = useState({
        supplierName: "",
        address: "",
        contactNumber: "",
        email: "",
        productSupplied: "",
        remark: "",
        status: true,
    });
    const [isUpdate, setIsUpdate] = useState(false);

    useEffect(() => {
        GetSupplierDetailsByid();
    }, [updateID])

    const handleClose = () => {
        setDialogOpen(false);
        ClearData();
        setIsUpdate(false);
        setUpdateID(0);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        setSupplierData({
            ...supplierData,
            [e.target.name]: value
        })
    }

    function handleStatusChange() {
        setSupplierData({
            ...supplierData,
            status: !supplierData.status
        })
    }

    function ClearData() {
        setSupplierData({
            ...supplierData,
            supplierName: "",
            address: "",
            contactNumber: "",
            email: "",
            productSupplied: "",
            remark: "",
            status: true,
        })
    }

    function UploadSupplier() {
        if (isUpdate) {
            const UpdateModel = {
                supplierName: supplierData.supplierName.trim(),
                address: supplierData.address.trim(),
                contactNumber: supplierData.contactNumber,
                email: supplierData.email,
                productSupplied: supplierData.productSupplied.trim(),
                remark: supplierData.remark.trim(),
                status: supplierData.status ? 1 : 0,
                updateID: updateID
            };

            axios.put('https://serverrion.mylksystems.store/Suppliers/updateSupplier', UpdateModel).then((res) => {
                if (res.data.affectedRows > 0) {
                    handleClose();
                    toast.success("Supplier Updated successfully!")
                }
            })


        } else {
            const SaveModel = {
                supplierName: supplierData.supplierName.trim(),
                address: supplierData.address.trim(),
                contactNumber: supplierData.contactNumber,
                email: supplierData.email,
                productSupplied: supplierData.productSupplied.trim(),
                remark: supplierData.remark.trim(),
                status: supplierData.status ? 1 : 0,
            };
            axios.post('https://serverrion.mylksystems.store/Suppliers/createSupplier', SaveModel)
                .then((res) => {
                    if (res.data > 0) {
                        ClearData();
                        handleClose();
                        toast.success("Supplier Added successfully!")
                    }
                })
                .catch((error) => {
                    toast.error("Error occured in supplier adding!")
                });
        }
    }

    function GetSupplierDetailsByid() {
        axios.get(`https://serverrion.mylksystems.store/Suppliers/getSupplierDetailsByID/${updateID}`).then((res) => {
            if (res.data.length > 0) {
                setSupplierData({
                    ...supplierData,
                    supplierName: res.data[0].SupplierName,
                    address: res.data[0].Address,
                    contactNumber: res.data[0].ContactNo,
                    email: res.data[0].Email,
                    productSupplied: res.data[0].ProductsSupplied,
                    remark: res.data[0].Remark,
                    status: res.data[0].IsActive == 1 ? true : false,
                })
                setIsUpdate(true);
            }
        })
    }

    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            open={dialogOpen}
            fullWidth={true}         // Ensures the dialog uses the full width of the container
            maxWidth='md'
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                {isUpdate ? 'Update Supplier' : 'Add Supplier'}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon sx={{ color: 'black' }} />
            </IconButton>
            <DialogContent dividers>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            supplierName: supplierData.supplierName,
                            address: supplierData.address,
                            contactNumber: supplierData.contactNumber,
                            email: supplierData.email,
                            productSupplied: supplierData.productSupplied,
                            remark: supplierData.remark,
                            status: supplierData.status,
                        }}

                        validationSchema={
                            Yup.object().shape({
                                supplierName: Yup.string()
                                    .required('Supplier Name is required')
                                    .test('no-leading-space', 'Supplier Name cannot start with a space', value => value && value.trim().length > 0),
                                address: Yup.string()
                                    .required('Supplier Address is required')
                                    .test('no-leading-space', 'Supplier Address cannot start with a space', value => value && value.trim().length > 0),
                                email: Yup.string()
                                    .required('Supplier Email is required')
                                    .test('no-leading-space', 'Supplier Email cannot start with a space', value => value && value.trim().length > 0)
                                    .email('Please enter a valid email address'),
                                contactNumber: Yup.string()
                                    .required('Supplier contact number is required'),
                                productSupplied: Yup.string()
                                    .required('Supplier Products is required')
                                    .test('no-leading-space', 'Supplier Products cannot start with a space', value => value && value.trim().length > 0)
                            })
                        }

                        onSubmit={() => UploadSupplier()}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Grid container spacing={2}>
                                        <Grid item md={6} xs={12}>
                                            <TextField
                                                fullWidth
                                                error={Boolean(touched.supplierName && errors.supplierName)}
                                                helperText={touched.supplierName && errors.supplierName}
                                                onBlur={handleBlur}
                                                label="Supplier Name *"
                                                name='supplierName'
                                                value={supplierData.supplierName}
                                                id='supplierName'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                                type='text'
                                            />
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <TextField
                                                fullWidth
                                                error={Boolean(touched.address && errors.address)}
                                                helperText={touched.address && errors.address}
                                                onBlur={handleBlur}
                                                label="Address *"
                                                name='address'
                                                value={supplierData.address}
                                                id='address'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                                type='text'
                                            />
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <TextField
                                                fullWidth
                                                error={Boolean(touched.email && errors.email)}
                                                helperText={touched.email && errors.email}
                                                label="Email *"
                                                name='email'
                                                value={supplierData.email}
                                                id='email'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                                type='text'
                                                onKeyDown={(e) => {
                                                    const validChars = /^[a-zA-Z0-9@._-]+$/;
                                                    if (!validChars.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <TextField
                                                fullWidth
                                                error={Boolean(touched.contactNumber && errors.contactNumber)}
                                                helperText={touched.contactNumber && errors.contactNumber}
                                                label="Contact Number *"
                                                name='contactNumber'
                                                value={supplierData.contactNumber}
                                                id='contactNumber'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                                type='text'
                                                onKeyDown={(e) => {
                                                    const value = e.target.value;
                                                    if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
                                                        e.preventDefault();
                                                    }
                                                    if (value.length >= 10 && e.key !== 'Backspace' && e.key !== 'Delete') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <TextField
                                                fullWidth
                                                error={Boolean(touched.productSupplied && errors.productSupplied)}
                                                helperText={touched.productSupplied && errors.productSupplied}
                                                label="Products Supplied *"
                                                name='productSupplied'
                                                value={supplierData.productSupplied}
                                                id='productSupplied'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                                type='text'
                                            />
                                        </Grid>
                                        <Grid item md={12} xs={12}>
                                            <TextField
                                                fullWidth
                                                error={Boolean(touched.remark && errors.remark)}
                                                helperText={touched.remark && errors.remark}
                                                label="Remark"
                                                name='remark'
                                                value={supplierData.remark}
                                                id='remark'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                                type='text'
                                                multiline
                                                rows={4}
                                            />
                                        </Grid>
                                        <Grid item md={6} xs={12} sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                                            <Typography>Active</Typography>
                                            &nbsp;
                                            <Switch
                                                checked={supplierData.status}
                                                onChange={handleStatusChange}
                                                status="isActive"
                                                label="Status"
                                            />

                                        </Grid>
                                        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            {isUpdate ? null :
                                                <Button
                                                    variant="contained"
                                                    type='submit'
                                                    sx={{ width: '30%' }}
                                                    onClick={ClearData}
                                                >
                                                    clear
                                                </Button>}
                                            &nbsp; &nbsp; &nbsp;
                                            <Button
                                                variant="contained"
                                                type='submit'
                                                sx={{ width: '30%' }}
                                            >
                                                {isUpdate ? 'Update' : 'Submit'}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </DialogContent>
        </Dialog>
    )
}
